const QUILL_FONT_SIZE_OPTIONS = [
  { value: '8px', label: '8' },
  { value: '9px', label: '9' },
  { value: '10px', label: '10' },
  { value: '11px', label: '11' },
  { value: '12px', label: '12' },
  { value: '14px', label: '14' },
  { value: '18px', label: '18' },
  { value: '24px', label: '24' },
  { value: '30px', label: '30' },
  { value: '36px', label: '36' },
  { value: '48px', label: '48' },
  { value: '60px', label: '60' },
  { value: '72px', label: '72' },
  { value: '96px', label: '96' },
] as const;

// Quill needs valid CSS size values for inline template HTML; the picker labels intentionally omit "px".
export const QUILL_FONT_SIZE_WHITELIST = QUILL_FONT_SIZE_OPTIONS.map(({ value }) => value);

export const QUILL_FONT_SIZE_LABEL_STYLES = Object.fromEntries(
  QUILL_FONT_SIZE_OPTIONS.map(({ value, label }) => [
    `& .ql-picker.ql-size .ql-picker-label[data-value="${value}"]::before, & .ql-picker.ql-size .ql-picker-item[data-value="${value}"]::before`,
    { content: `"${label}"` },
  ])
);
